import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
// import { Link as ScrollLink } from 'react-scroll';
import './styles.css';

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const scrollOrNavigate = (targetId) => {
        if (location.pathname === "/") {
            const element = document.getElementById(targetId);
            if (element) {
                const yOffset = -60;
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: "smooth" });
            }
        } else {
            // Go to homepage and scroll after navigation
            navigate("/", { state: { scrollTo: targetId } });
        }
    };


    return (
        <div id={'Header'}>
            <div>
                <button onClick={() => scrollOrNavigate('HomePage')}>Home</button>
                <button onClick={() => scrollOrNavigate('AboutPage')}>About Us</button>
                <button onClick={() => scrollOrNavigate('ReviewsPage')}>Reviews</button>
                <Link to={'/meet'}>
                    <button>Practitioners</button>
                </Link>
            </div>
            <div id={"contactTab"}>
                <button onClick={() => scrollOrNavigate('Footer')}>Contact Us</button>
            </div>
        </div>
    );
}

export default Header;
